export default __webpack_public_path__ + "static/media/mockup.19cdd32d.png";